import { IconLibrary, ThriveIcon } from "thrive-components";

interface ICalendarButton {
    content: string | JSX.Element;
    className?: string,
    ariaLabel: string,
    onButtonClick: any
}

const CalendarButton = ({ content, className, ariaLabel, onButtonClick}: ICalendarButton) => {

    return (
        <button
            className={`basic-calendar-button ${className}`}
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type={'button'}
        >
            {content}
            <ThriveIcon iconName={IconLibrary.CALENDAR} sizeInPx="12" />
        </button>
    );
};

export default CalendarButton